import { MdQuestionMark, MdOutlineEmail} from 'react-icons/md';
import {  FaPhone,FaLongArrowAltLeft,FaLongArrowAltRight,FaUsers,FaHome   } from 'react-icons/fa';
import { FaRegMessage} from "react-icons/fa6";
import { LuNotebookPen } from "react-icons/lu";
import { BsBoxSeamFill } from "react-icons/bs";
import { GoProjectSymlink } from "react-icons/go";
import { PiUsersThreeBold } from "react-icons/pi";
  

const Sidebar = ({ isCollapsed, toggleSidebar }) => {
  const navItems = [
    { name: 'Home', path: '/dashboard', icon: <FaHome  size={24} /> },
   { name: 'Companies', path: '/dashboard/customers', icon: <PiUsersThreeBold size={24} /> },
    { name: 'Products', path: '/dashboard/products', icon: <BsBoxSeamFill  size={24} /> },
    { name: 'Permits', path: '/dashboard/permits', icon: <LuNotebookPen  size={24} /> },
    { name: 'Users', path: '#', icon: <FaUsers  size={24} /> },
  ];

  return (
    <nav
      className={`bg-gray-100 h-full fixed top-18 bottom-0 transition-all duration-300 z-20 p-4  ${
        isCollapsed ? 'w-16' : 'w-40'
      }`}
  
      
    >
      <div className="flex flex-col h-full">
        {/* Toggle Button */}
        <button
          className="p-2 text-center text-bold text-lghover:bg-gray-200 text-gray-800 mb-4"
          onClick={toggleSidebar}
        >
          {isCollapsed ? <FaLongArrowAltRight /> : <FaLongArrowAltLeft />}
        </button>

        {/* Navigation Items */}
        <ul className="space-y-2">
          {navItems.map((item, index) => (
            <li key={index} className="relative group">
              <a
                href={item.path}
                className="flex items-center p-2 rounded hover:bg-gray-200 text-gray-800"
              >
                <span className="flex-shrink-0">{item.icon}</span>
                {!isCollapsed && (
                  <span className="ml-4 text-md">{item.name}</span>
                )}
              </a>
              {isCollapsed && (
                <div className="absolute left-full top-0 mt-2 ml-2 hidden group-hover:block bg-gray-700 text-white text-sm rounded-md px-3 py-2 z-30">
                  {item.name}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Sidebar;